import React, { useEffect, useState } from 'react';
import { localizedValue } from '../../localization/presentationLanguage';

const styles = {
  wrapper: {
    display: 'inline-flex',
    gap: 6,
    padding: 6,
    borderRadius: 999,
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(218,165,32,0.18)',
  },

  wrapperMobile: {
    width: '100%',
    display: 'flex',
    gap: 8,
    padding: 6,
  },

  button: {
    border: 'none',
    outline: 'none',
    padding: '10px 18px',
    borderRadius: 999,
    fontWeight: 800,
    fontSize: 13,
    cursor: 'pointer',
    background: 'transparent',
    color: 'rgba(255,243,196,0.65)',
    transition: 'all 0.18s ease',
    WebkitTapHighlightColor: 'transparent',
    touchAction: 'manipulation',
    userSelect: 'none',
  },

  buttonMobile: {
    flex: 1,
    minHeight: 46,
    fontSize: 14,
    padding: '12px 10px',
    borderRadius: 18,
  },

  active: {
    background: 'linear-gradient(135deg,#DAA520,#F2C94C)',
    color: '#2a1600',
    boxShadow: '0 6px 18px rgba(218,165,32,0.25)',
  },
};

export default function ModeToggle({ mode = 'quick', onChange = () => {} }) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth <= 768;
  });

  useEffect(() => {
    let timer;

    function check() {
      clearTimeout(timer);
      timer = setTimeout(() => {
        setIsMobile(window.innerWidth <= 768);
      }, 100);
    }

    check();
    window.addEventListener('resize', check);

    return () => {
      window.removeEventListener('resize', check);
      clearTimeout(timer);
    };
  }, []);

  return (
    <div style={{ ...styles.wrapper, ...(isMobile ? styles.wrapperMobile : null) }}>
      <button
        type="button"
        onClick={() => onChange?.('quick')}
        style={{
          ...styles.button,
          ...(isMobile ? styles.buttonMobile : null),
          ...(mode === 'quick' ? styles.active : null),
        }}
      >
        {localizedValue({ es: '☀ Compatibilidad Solar', en: '☀ Solar Compatibility' })}
      </button>

      <button
        type="button"
        onClick={() => onChange?.('deep')}
        style={{
          ...styles.button,
          ...(isMobile ? styles.buttonMobile : null),
          ...(mode === 'deep' ? styles.active : null),
        }}
      >
        {localizedValue({ es: '✦ Sinastría Completa', en: '✦ Full Synastry' })}
      </button>
    </div>
  );
}
